import axiosClient from '../axiosClient';

const historyBookingAPI = {
    async getListHistoryBookingAPI(params) {
        const url = `/booking/history`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneHistoryBookingAPI(id, params) {
        const url = `/booking/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async cancelBookingAPI(id) {
        const url = `/booking/${id}/cancel`;
        const resp = await axiosClient.put(url);
        return resp;
    },
};

export default historyBookingAPI;
